"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCoverImage = void 0;
var is_valid_url_1 = require("@wix/communities-blog-universal/dist/src/utils/is-valid-url");
var getCoverImage = function (post) {
    var _a, _b, _c, _d, _e;
    var _f = (_e = (_b = (_a = post.coverMedia) === null || _a === void 0 ? void 0 : _a.image) !== null && _b !== void 0 ? _b : (_d = (_c = post.coverMedia) === null || _c === void 0 ? void 0 : _c.video) === null || _d === void 0 ? void 0 : _d.thumbnail) !== null && _e !== void 0 ? _e : {}, id = _f.id, width = _f.width, height = _f.height, url = _f.url;
    var isWixImage = id && width && height;
    if (isWixImage) {
        return {
            coverImage: (0, is_valid_url_1.isValidUrl)(id) ? id : "wix:image://v1/" + id + "/" + id + "#originWidth=" + width + "&originHeight=" + height,
        };
    }
    return url && (0, is_valid_url_1.isValidUrl)(url) ? { coverImage: url } : {};
};
exports.getCoverImage = getCoverImage;
//# sourceMappingURL=get-cover-image.js.map